import { render, staticRenderFns } from "./PriceInventoryNormal.vue?vue&type=template&id=9285e69e&scoped=true&"
import script from "./PriceInventoryNormal.vue?vue&type=script&lang=js&"
export * from "./PriceInventoryNormal.vue?vue&type=script&lang=js&"
import style0 from "./PriceInventoryNormal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PriceInventoryNormal.vue?vue&type=style&index=1&id=9285e69e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9285e69e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9285e69e')) {
      api.createRecord('9285e69e', component.options)
    } else {
      api.reload('9285e69e', component.options)
    }
    module.hot.accept("./PriceInventoryNormal.vue?vue&type=template&id=9285e69e&scoped=true&", function () {
      api.rerender('9285e69e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/publishGoods/components/PriceInventoryNormal.vue"
export default component.exports